import TodoList from "../todo/todo-list/todo-list"
import TodoItem from "../todo/todo-item/todo-item"
import {ToDoAccess} from "../../gd-modules/todos/@type";
import {TodoType} from "../todo/@type";
import TodoItem_Collection from "../todo/todo-item/collection";

const debug = false
// const debug = "TodoManager"

export default class TodoManager {

    private app     : any
    private access  : any
    public lists    : TodoList[] //| false

    constructor(app:any, access:ToDoAccess, serializedTodoLists:JSONArray) {
        this.app    = app
        this.access = access

        this.lists  = [] //false
        this.normalize(serializedTodoLists)

        debug && console.log(debug, "constructor", access, serializedTodoLists, this.lists)
    }

    reset(serializedTodoLists:JSONArray) {
        this.normalize(serializedTodoLists);
        gd.bus.triggerEvent('task-view:todo-lists-change');
    }

    getCompletedItemsCounter() {
        return _.sumBy(this.lists, (list)=>list.completedItemsLength)
    }

    get uncompletedItemsTotal() {
        return _.sumBy(this.lists, (list)=>list.uncompletedItemsTotal)
    }



    get isEmpty():boolean {
        return _.isEmpty(this.lists)
    }

    get total() {
        return this.getItemsCounter()
    }

    getItemsCounter() {
        return _.sumBy(this.lists, list=>list.length)
    }

    normalize(data:any) {
        if (data && data.length>0) {
            this.lists = [];

            // check if it is OLD or new format
            if (data[0].hasOwnProperty('momentCreated')) {
                // this is NEW format
                const uids = _(data).map((todoListRaw)=> todoListRaw.uid).compact().value()
                _.map(data, (todoListRaw)=> {
                    if (!todoListRaw.uid) {
                        todoListRaw.uid = gd.utils.generateUIDWithCollisionChecking(uids)
                        uids.push(todoListRaw.uid)
                    }
                    const todoList = new TodoList(todoListRaw, this.access)
                    this.lists.push(todoList)
                })
            } else if (data[0].label) {
                // this is OLD format
                const uids = _(data).map(todoListRaw=>todoListRaw.uid).compact().value()
                _.map(data, todoListRaw=>{
                    if (!todoListRaw.uid) {
                        todoListRaw.uid = gd.utils.generateUIDWithCollisionChecking(uids)
                        uids.push(todoListRaw.uid)
                    }

                    _.map(todoListRaw.items, (item)=> {
                        item.properties = {
                            title       : item.title,
                            completed   : item.checked,
                            messageId   : item.messageId,
                            userId      : item.userId
                        }
                    })

                    const todoList: TodoList = new TodoList({
                        uid     : todoListRaw.uid,
                        title   : todoListRaw.label,
                    }, this.access)

                    todoList.items = TodoItem_Collection.initFromJson(todoListRaw.items, todoList)

                    this.lists.push(todoList)
                })

            } else {
                // this is THE OLDEST format
                _.map(data, item=>{
                    item.properties = {
                        title       : item.title,
                        completed   : item.checked
                    }
                })

                const todoList = new TodoList({
                    uid     : gd.utils.generateUIDWithCollisionChecking(),
                    title   : 'ToDo',
                    items   : data
                }, this.access)
                this.lists.push(todoList)
            }
        } else {
            this.lists = [];
        }
    }

    newEmptyTodoList(autosave=true) {
        let title = 'Todo List'

        if (this.lists && this.lists.length > 0) title += ' ' + (this.lists.length + 1)
        if (!this.lists) this.lists = []

        const uids = _.map(this.lists, list=>list.uid)

        const newTodoList = TodoList.create(this, {
            uid     : gd.utils.generateUIDWithCollisionChecking(uids),
            title   : title,
            items   : [],
        });

        this.lists.push(newTodoList)

        if (autosave) this.save()
    }

    // create new to-do item from task message
    newTodoFromMessage(message:any, todoListId?: ID) {
        // check if already has to-do item

        // create new list if non
        if (_.isEmpty(this.lists)) {
            this.newEmptyTodoList(false)
        }

        const title = message.message ? message.message.substring(0,100) : ''

        const todoList = todoListId ? _.find(this.lists, list=>list.uid === todoListId) : this.lists[0]

        const messageHasInList = todoList?.messageHasInList(message.id)

        if(!!messageHasInList) {
            return
        }

        const newTodoListItem = TodoItem.create(todoList!, {
            type        : TodoType.TODO,
            properties  : {
                title,
                messageId   : message.id
            }
        })

        // @ts-ignore
        todoList.addItem(newTodoListItem)

        _.map(this.lists, (list: TodoList)=>{

            if (todoList?.uid !== list.uid && list.messageHasInList(message.id)) {

                const itemWithMessage = list.getItemByMessageId(message.id)

                if (itemWithMessage?.uid) {
                    list.deleteItem(itemWithMessage.uid)
                }
            }
        })

        this.save()
    }

    hasInLists = (messageId: ID)=> {

        let hasInLists = false

        _.map(this.lists, (list: TodoList)=> {
            if(list.messageHasInList(messageId)){
                hasInLists = true
            }
        })

        return hasInLists
    }

    removeFromAllLists = (messageId: ID)=> {
        _.map(this.lists, (list: TodoList)=>{
            if (list.messageHasInList(messageId)) {

                const itemWithMessage = list.getItemByMessageId(messageId)

                if (itemWithMessage?.uid) {
                    list.deleteItem(itemWithMessage.uid)
                }
            }
        })

        this.save()

    }

    newTodoListFromTemplate(callback?: callback, autosave: boolean = true) {
        return new Promise((resolve, reject) => {
            gd.modals.task.addTodoList(gd.companyId, (title:string, items:any)=>{
                const found = _.find(this.lists, l=>l.title === title)
                if (found && this.lists && this.lists.length > 0) title += ' ' + (this.lists.length + 1)
                if (!this.lists) this.lists = []

                const uids = _.map(this.lists, list=>list.uid)

                this.lists.push(TodoList.create(this, {
                    uid     : gd.utils.generateUIDWithCollisionChecking(uids),
                    title   : title,
                    items   : items.map((todo:TodoItem)=>({
                        type        : TodoType.TODO,
                        properties  : {title: todo}
                    }))
                }))

                if (autosave) this.save()
                resolve(true)
            })
        })
    }

    deleteTodoList(uid:ID) {
        _.remove(this.lists, list=>list.uid === uid)
        this.save()
    }

    // return all taskMessageIds from all to-do lists
    findAllTaskMessages() {
        const result : any[] = []
        if (this.lists) {
            _.map(this.lists, todoList=>{
                _.map(todoList.items.models, todoItem=>{
                    if (todoItem.properties.messageId) {
                        result.push(todoItem.properties.messageId)
                    }
                })
            })
        }
        return result
    }

    findTodoListByTaskMessageId(taskMessageId:ID): TodoList | null {
        let res = null

        if (this.lists) {
            _.some(this.lists, todoList=>{
                const item = _.find(todoList.items.models, todoItem=>todoItem.properties.messageId === taskMessageId)
                if (item) {
                    res = todoList
                    return true
                }
            })
        }

        return res
    }

    toJSON = () => _.map(this.lists, todoList=>todoList.toJSON())

    save() {
        gd.api.Task.saveChecklist(this.app.taskId, this.toJSON())

        // experimental
        gd.bus.triggerEvent('task-view:todo-lists-change')
    }
}
